export interface ITtQuote {
  orderNumber: string;
  scenarioId: string;
  customerId: string;
  purchaseOrderNo: string;
  netValue: string;
  guid: string;
  description: string;
  currency: string;
  status: string;
  statusText: string;
  validFrom: string;
  validTo: string;
  isExpired: boolean;
  createdOn: string;
  validToGA: string;
  netValueGA: string;
  statusTextGA: string;
}

export interface ITtQuoteDetail {
  quotationId: string;
  customerPO: string;
  quotationStatus: string;
  notes: any;
  validFrom: string;
  validUntil: string;
  quotationType: string;
  quotationTypeText: string;
  paymentTerms: string;
  totalListPrice: string;
  totalNetPrice: string;
  statusText: string;
  statusTextGA: string;
  validUntilGA: string;
  quotationTypeGA: string;
  totalListPriceGA: string;
  totalNetPriceGA: string;
  items: ITtQuoteDetailItem[];
  itemsAggregated: { [key: string]: ITtQuoteDetailItem[] };
  salesOrders: { [key: number]: string };
}

export interface ITtQuoteDetailItem {
  position: number;
  articleNo: string;
  articleDescription: string;
  quantity: number;
  quantityInSessionCart: number;
  quantityUnit: string;
  type: string;
  offeredPrice?: string;
  grossListPrice: string;
  offeredPriceGA: string;
  grossListPriceGA: string;
  components?: ITtQuoteDetailSubitem[];
  erpItemNo?: number;
  analyticsData: ITtAnalyticsData;
}

export interface ITtAnalyticsData {
  productName: string;
  productId: string;
  productPrice: string;
  currency: string;
  productBrand: string;
  category: string;
  variant: string;
  quantity: number;
}

export interface ITtQuoteDetailSubitem {
  position: number;
  articleNo: string;
  articleDescription: string;
  quantity: number;
  quantityUnit: string;
}

export enum TtQuoteDetailItemType {
  LINE = "LINE",
  PACKAGE = "PACKAGE",
  OPTIONAL = "OPTIONAL",
  FREE_OF_CHARGE = "FREE_OF_CHARGE",
  ORDERED = "ORDERED",
  DUMMY_MATERIALS = "DUMMY_MATERIALS",
  SERVICE_ITEMS = "SERVICE_ITEMS",
  OPTIONAL_PACKAGE = "OPTIONAL_PACKAGE",
}

export interface ITtAddQuoteToOrderToCartRequest {
  optionalItems: Array<Partial<ITtQuoteDetailSubitem>>;
  partialItems: Array<Partial<ITtQuoteDetailSubitem>>;
}

export enum TtQuotationStatus {
  Open = "Open",
  Completed = "Completed",
  BeingProcessed = "Being processed",
  Cancelled = "Cancelled",
}

export const AmountOfCharacters = 51;

export enum TtIcons {
  ArrowUp = "up",
  ArrowDown = "down",
}

export enum TtQuotationType {
  Partial = "Partial",
  Complete = "Complete",
}

export interface ISortByOption {
  value: string;
  label: string;
}

export enum TtSortByOption {
  Position = "LINE_NUMBER",
  ArticleNo = "CODE",
  ArticleDescription = "DESCRIPTION",
  Price = "PRICE",
}

export const optionalTypes: Partial<TtQuoteDetailItemType[]> = [
  TtQuoteDetailItemType.OPTIONAL,
  TtQuoteDetailItemType.OPTIONAL_PACKAGE,
];

export const unorderedTypes: Partial<TtQuoteDetailItemType[]> = [
  TtQuoteDetailItemType.DUMMY_MATERIALS,
  TtQuoteDetailItemType.SERVICE_ITEMS,
];

export enum AggregationTypes {
  Items,
  AggregatedItems,
  MixedItems,
}
